/*eslint-disable*/
export default {
    props: ['answerDuration'],
    data () {
        return {
            answerTime: 0,
            answerTimeInterval: null
        }
    },
    watch: {
        answerTime (val) {
            if (val >= this.currentAnswerDuration) {
                this.answer = false;
                this.checkAnswer();
            }
        }
    },
    methods: {
        trackTime () {
            if (this.currentAnswerDuration) {
                this.answerTime = 0;
                this.answerTimeInterval = setInterval(() => {
                    this.answerTime++;
                }, 1000);
            }
        },
        stopTracking () {
            if (this.currentAnswerDuration) {
                this.answerTime = 0;
                clearInterval(this.answerTimeInterval);
            }
        }
    },
    computed: {
        currentAnswerDuration () {
            if (this.parameters && (this.parameters.answerDuration || (this.type === 'MultiplicationAndDivision' && this.isOlympiad && this.parameters.timeForAnswer != '-1'))) {
                return this.parameters.answerDuration || this.parameters.timeForAnswer;
            }
            return this.answerDuration;
        }
    },
    beforeDestroy () {
        this.stopTracking();
    }
}
